module.exports = __webpack_public_path__ + "images/3a0796260ee7756307a1f3be5fe59b4a-win.jpg";